<script setup>
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { ref } from "vue";
import { twMerge } from "tailwind-merge";

const props = defineProps({
    dismissible: {
        type: Boolean,
        default: true,
    },
    class: String,
});

const open = ref(false);

const show = () => {
    open.value = true;
};

const hide = () => {
    open.value = false;
};

defineExpose({ show, hide });
</script>

<template>
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="z-[100000] relative" @close="dismissible ? hide() : undefined">
            <TransitionChild
                as="template"
                enter="ease-out duration-300"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="ease-in duration-200"
                leave-from="opacity-100"
                leave-to="opacity-0">
                <div class="bg-black/80 bg-opacity-75 fixed inset-0 transition-opacity" />
            </TransitionChild>

            <div class="z-[100000] overflow-y-auto fixed inset-0">
                <div class="min-h-full flex justify-center items-end p-4 sm:items-center sm:p-0">
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel
                            :class="[
                                twMerge(
                                    'relative shadow-xl transition-all transform bg-white dark:bg-gray-900 sm:my-8 w-full sm:max-w-lg rounded-lg border border-gray-300 dark:border-gray-800',
                                    props.class
                                ),
                            ]">
                            <slot></slot>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
